import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY || '';
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com';

let initialized = false;

export function initPostHog() {
  if (initialized || !POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,           // Auto-track clicks, inputs, page views
    capture_pageview: true,      // Auto-track page views
    capture_pageleave: true,     // Track when users leave
    session_recording: {
      recordCrossOriginIframes: false,
    },
    persistence: 'localStorage',
    loaded: (ph) => {
      if (import.meta.env.DEV) {
        // Disable in development to avoid polluting data
        ph.opt_out_capturing();
      }
    },
  });

  initialized = true;
}

/**
 * Identify a logged-in user so all events are tied to them.
 */
export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, properties);
}

/**
 * Reset identity on logout.
 */
export function resetUser() {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}

/**
 * Track a custom event.
 */
export function trackEvent(event: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

export { posthog };
